var enterprises = {
    //Return a array
    async getAll() {
        const db = window.firebase.firestore();
        let enterprises = [];
        var e = await db.collection("/enterprises")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    enterprises.push(
                        doc.data()

                    );
                    console.log(doc.id, " => ", doc.data());
                });
                console.log("will return")
                return enterprises
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
                return error;
            });
        return e;
    },
    async getFromId(id) {
        console.log("getEnterprise:" + id)
        const db = window.firebase.firestore();
        let objects = [];
        var e = await db.collection("/enterprises")
            .where("id", "==", id).get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    var d = doc.data();
                    d.id = doc.id;
                    objects.push(
                        doc.data()
                    );

                    console.log(doc.id, " => ", doc.data());
                });
                console.log("will return")
                console.log(JSON.stringify(objects))
                return objects[0];
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
                return error;
            });

        console.log(JSON.stringify(e))
        return e;
    },
    async patch(enterprise) {
        console.log("patch:" + JSON.stringify(enterprise))
        if (enterprise.name === undefined) enterprise.name = "";
        if (enterprise.cnpj === undefined) enterprise.cnpj = "";
        if (enterprise.ie === undefined) enterprise.ie = "";
        if (enterprise.phone === undefined) enterprise.phone = "";
        if (enterprise.address === undefined) enterprise.address = "";
        if (enterprise.zipCode === undefined) enterprise.zipCode = "";
        if (enterprise.cityName === undefined) enterprise.cityName = "";


        const db = window.firebase.firestore();
        var ref = db.collection("enterprises")
        var e = await ref.doc(enterprise.id).set(enterprise)
            .then((docRef) => {
                console.log("Document successfully updated!" + JSON.stringify(docRef));
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        return e;
    },
    async post(enterprise) {
        if (enterprise.name === undefined) enterprise.name = "";
        if (enterprise.cnpj === undefined) enterprise.cnpj = "";
        if (enterprise.ie === undefined) enterprise.ie = "";
        if (enterprise.phone === undefined) enterprise.phone = "";
        if (enterprise.address === undefined) enterprise.address = "";
        if (enterprise.zipCode === undefined) enterprise.zipCode = "";
        if (enterprise.cityName === undefined) enterprise.cityName = "";
        const db = window.firebase.firestore();
        var ref = db.collection("enterprises")
        var e = await ref.add(enterprise)
            .then((docRef) => {
                console.log("Document successfully created!");
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });

        //return e;

        enterprise.id = e.id;
        var a = await this.patch(enterprise);
        return e;
    },

    async upsert(enterprise) {
        var d = Object.assign({}, enterprise)
        //If there'is a enterpriseId, save , otherwise, add
        if (enterprise.id) {
            var a = await this.patch(enterprise);
            return enterprise;
        }
        const db = window.firebase.firestore();
        var ref = db.collection("databases/" + window.eid + "/enterprises")
        var e = await ref.add(d)
            .then((docRef) => {
                console.log("Document successfully created!");
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        d.id = e.id;
        var a = await this.patch(d);
        return d;
    },


}

export default enterprises;